import React from 'react';
import PropTypes from 'prop-types';
import { iconGray } from '../../theme';

const Card = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 39.417 27.194">
    <g id="Group_1725" transform="translate(-8.615 -10.17)">
      <g id="Group_1755" transform="translate(8.615 10.17)">
        <path
          d="M48.191,43.819h-28.8a5.315,5.315,0,0,1-5.309-5.309V21.934a5.315,5.315,0,0,1,5.309-5.309h28.8A5.315,5.315,0,0,1,53.5,21.934V38.51a5.315,5.315,0,0,1-5.309,5.309m-28.8-24.8a2.915,2.915,0,0,0-2.911,2.911V38.51a2.915,2.915,0,0,0,2.911,2.911h28.8A2.914,2.914,0,0,0,51.1,38.51V21.934a2.915,2.915,0,0,0-2.911-2.911Z"
          transform="translate(-14.083 -16.625)"
          fill={color}
        />
        <path
          d="M56.958,25.96a2.387,2.387,0,1,1-2.387-2.386,2.387,2.387,0,0,1,2.387,2.386"
          transform="translate(-23.512 -18.345)"
          fill={color}
        />
        <path
          d="M25.242,39.626H21.778a1.2,1.2,0,1,1,0-2.4h3.464a1.2,1.2,0,1,1,0,2.4"
          transform="translate(-15.691 -21.724)"
          fill={color}
        />
        <path
          d="M35.266,39.626H31.8a1.2,1.2,0,1,1,0-2.4h3.464a1.2,1.2,0,1,1,0,2.4"
          transform="translate(-18.171 -21.724)"
          fill={color}
        />
        <path
          d="M45.29,39.626H41.826a1.2,1.2,0,1,1,0-2.4H45.29a1.2,1.2,0,1,1,0,2.4"
          transform="translate(-20.652 -21.724)"
          fill={color}
        />
        <path
          d="M55.314,39.626H51.85a1.2,1.2,0,1,1,0-2.4h3.464a1.2,1.2,0,1,1,0,2.4"
          transform="translate(-23.133 -21.724)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

Card.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Card.defaultProps = {
  width: 39.417,
  height: 27.194,
  color: iconGray,
};

export default Card;
